import React, { useState } from 'react';
import { Textarea as BaseTextarea } from '@qga/roo-ui/components';
import pluralize from 'pluralize';
import PropTypes from 'prop-types';

import FormErrorMessage from '@/shared/components/FormErrorMessage';

const remainingTextLabel = (limit, length = 0) => {
  const num = limit - length;
  return (
    <span data-testid="CHARACTER_LIMIT">
      {`${num} ${pluralize('character', num)} remaining`}
    </span>
  );
};

const Textarea = ({
  error,
  characterLimit,
  value,
  onChange = () => undefined,
  ...props
}) => {
  const [valLength, setValLength] = useState(value && value.length);

  return (
    <div>
      <BaseTextarea
        value={value}
        error={!!error}
        onChange={(e) => {
          if (e.target.value.length > characterLimit) {
            e.target.value = e.target.value.substring(0, characterLimit);
          }
          setValLength(e.target.value.length);
          onChange(e);
        }}
        {...props} // eslint-disable-line
      />
      {error && <FormErrorMessage text={error} />}
      {characterLimit && remainingTextLabel(characterLimit, valLength)}
    </div>
  );
};

Textarea.propTypes = {
  characterLimit: PropTypes.number,
  error: PropTypes.string,
  onChange: PropTypes.func,
  ...Textarea.propTypes,
};

export default Textarea;
